// https://github.com/katzer/cordova-plugin-local-notifications
// https://web.dev/push-notifications-display-a-notification/

// project imports
import { AuthHeader, ApiUrl } from 'utils/Constants';
import { UserData, Logout } from 'utils/User';
import { isMobile } from 'utils/Device';

export const listenChannels = async () => {
    let arrChannels = [];

    const res = await fetch(`${ApiUrl}/api/basis`, {
        headers: AuthHeader
    });
    const response = await res.json();
    const data = response.data;
    if (response.success) {
        data.forEach((group) => {
            arrChannels.push('group.' + group.id);
        });

        // user channel
        arrChannels.push('user.' + UserData()?.Id);
        // public channel
        arrChannels.push('public');

        listen(arrChannels);
    }
};

export default listenChannels;

export const listen = async (arrChannels = [], handleEvent) => {
    if (!window.Pusher) return false;

    let pusher = new Pusher('917b5d5e6309ec85b0de', {
        authEndpoint: ApiUrl + '/api/pusher/auth',
        encrypted: true,
        cluster: 'ap2',
        auth: {
            headers: {
                Authorization: AuthHeader.Authorization
            }
        }
    });

    const title = 'مبیسان';
    const smallicon = './favicon-192.png';
    const icon = './favicon-192.png';

    showMessage(title, smallicon, icon);

    arrChannels.forEach((name) => {
        // Subscribe to the channel we specified in our Server Event
        let channel = pusher.subscribe('channel.' + name);

        // Bind a function to an Event (the full Server class)
        channel.bind_global((eventName, data) => {
            if (!data.message) return false;

            if (handleEvent) {
                handleEvent(data.message);
            } else {
                showMessage(title, smallicon, icon);
            }
        });
    });

    /*
    arrChannels.forEach((name) => {
        // Subscribe to the channel we specified in our Server Event
        let channel = pusher.subscribe('channel.' + name);

        // Bind a function to an Event (the full Server class)
        channel.bind_global((eventName, data) => {
            if (!data.message) return false;

            console.log(data.message);
        });
    });
    */
};

const getMessages = async () => {
    const res = await fetch(`${ApiUrl}/api/message?undone=1&remove=1`, {
        headers: AuthHeader
    });
    const response = await res.json();
    const data = response.data;
    if (response.success) {
        return data;
    } else {
        return [];
    }
};

const showMessage = async (title, smallicon, icon) => {
    const arrNotify = [];

    const messages = []; //await getMessages();
    messages.forEach((message) => {
        if (isMobile) {
            arrNotify.push({
                id: message.id,
                title: title,
                text: message.text,
                smallIcon: 'res://favicon_mono_128',
                icon: 'res://favicon_192',
                foreground: true
            });
        } else {
            notifyWeb(title, message.text, icon, smallicon, '#');
        }
    });
    // is mobile send arrNotify
    if (isMobile && arrNotify.length > 0) {
        cordova.plugins.notification.local.hasPermission(function (granted) {
            if (granted) {
                cordova.plugins.notification.local.schedule(arrNotify);
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', function () {
    if (!Notification) {
        alert('Desktop notifications not available in your browser. Try Chromium.');
        return;
    }

    if (Notification.permission !== 'granted') Notification.requestPermission();
});

const notifyWeb = (title, message, icon, badge, url) => {
    if (Notification.permission !== 'granted') Notification.requestPermission();
    else {
        var notification = new Notification(title, {
            body: message,
            icon: icon,
            badge: badge
        });

        setTimeout(function () {
            notification.close();
        }, 15000);

        notification.onClick = function () {
            if (url == '#') {
                window.focus();
            } else {
                window.open(url);
            }
        };
    }
};
